import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface BreakdownRow {
  category: string;
  volume: string;
  share: string;
  change: string;
  isSubItem?: boolean;
  isTotal?: boolean;
}
interface BreakdownTableProps {
  rows: BreakdownRow[];
}
type PivotOption = '3DS outcome' | 'Card brand' | 'Card country' | 'Card type' | 'Currency' | 'CVC response' | 'Input method' | 'Interaction type' | 'Network token status' | 'Postal code response' | 'Retry status';
export function BreakdownTable({
  rows
}: BreakdownTableProps) {
  const [pivotBy, setPivotBy] = useState<PivotOption>('Card type');
  const [showPivotDropdown, setShowPivotDropdown] = useState(false);
  const pivotRef = useRef<HTMLDivElement>(null);
  const pivotOptions: PivotOption[] = ['3DS outcome', 'Card brand', 'Card country', 'Card type', 'Currency', 'CVC response', 'Input method', 'Interaction type', 'Network token status', 'Postal code response', 'Retry status'];
  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (pivotRef.current && !pivotRef.current.contains(event.target as Node)) {
        setShowPivotDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-759">
      <div className="flex items-center gap-2 mb-4" data-id="element-760">
        <span className="text-sm text-gray-700" data-id="element-761">Pivot by</span>
        <div className="relative" ref={pivotRef} data-id="element-762">
          <button onClick={() => setShowPivotDropdown(!showPivotDropdown)} className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-50" data-id="element-763">
            <span data-id="element-764">{pivotBy}</span>
            <ChevronDownIcon size={16} data-id="element-765" />
          </button>

          {showPivotDropdown && <div className="absolute left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50 max-h-80 overflow-y-auto" data-id="element-766">
              {pivotOptions.map(option => <button key={option} onClick={() => {
            setPivotBy(option);
            setShowPivotDropdown(false);
          }} className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 flex items-center justify-between ${pivotBy === option ? 'text-gray-900 font-medium' : 'text-gray-700'}`} data-id="element-767">
                  <span data-id="element-768">{option}</span>
                  {pivotBy === option && <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="text-blue-600" data-id="element-769">
                      <path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-770" />
                    </svg>}
                </button>)}
            </div>}
        </div>
      </div>

      <table className="w-full" data-id="element-771">
        <thead data-id="element-772">
          <tr className="border-b border-gray-200" data-id="element-773">
            <th className="text-left text-sm font-medium text-gray-700 pb-3" data-id="element-774">
              Category
            </th>
            <th className="text-right text-sm font-medium text-gray-700 pb-3" data-id="element-775">
              Payment volume
            </th>
            <th className="text-right text-sm font-medium text-gray-700 pb-3" data-id="element-776">
              Share of volume
            </th>
            <th className="text-right text-sm font-medium text-gray-700 pb-3" data-id="element-777">
              Change
            </th>
          </tr>
        </thead>
        <tbody data-id="element-778">
          {rows.map((row, index) => <tr key={index} className={row.isTotal ? 'border-t-2 border-gray-300' : 'border-b border-gray-200'} data-id="element-779">
              <td className={`py-3 text-sm ${row.isTotal ? 'font-semibold text-gray-900' : row.isSubItem ? 'text-gray-600 pl-6' : 'font-medium text-gray-900'}`} data-id="element-780">
                {row.category}
              </td>
              <td className={`py-3 text-sm text-right ${row.isTotal ? 'font-semibold text-gray-900' : row.isSubItem ? 'text-gray-600' : 'text-gray-900'}`} data-id="element-781">
                {row.volume}
              </td>
              <td className={`py-3 text-sm text-right ${row.isTotal ? 'font-semibold text-gray-900' : row.isSubItem ? 'text-gray-600' : 'text-gray-900'}`} data-id="element-782">
                {row.share}
              </td>
              <td className={`py-3 text-sm text-right ${row.change.startsWith('-') ? 'text-red-600' : row.change.startsWith('+') ? 'text-green-600' : ''}`} data-id="element-783">
                {row.change}
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}